import * as Sentry from '@sentry/browser';

export function sentryInit() {
    var hostname = window.location.hostname;
    if (hostname != "localhost") {
        Sentry.init({
            dsn: "https://448dbd55f5764e45b862756c4d664e18@sentry.io/2599015",
            //ignoreErrors: [
            //    "Can't execute code from freed script",
            //    "SecurityError",
            //    "Failed to fetch",
            //    "ga.getAll is not a function",
            //    "Unable to get property 'sqrt' of undefined or null reference"
            //],
            beforeSend: (event, hint) => {
                if (event.platform == "XiaoMi") {
                    return null;
                }
                return event;
            }
        });
        Sentry.configureScope((scope) => {
            scope.addEventProcessor(async (event) => {
                return event;
            });
        });
    }
}